export const MOBILE_DEVICES = ['base', 'sm'];

export const ROUTES = [
	{ to: '/', label: 'HOME' },
	{ to: '/skills', label: 'SKILLS' },
	{ to: '/contact', label: 'CONTACT' },
	{ to: '/projects', label: 'PROJECTS' },
];

export const PAGE_TITLES = {
	about: 'Home | Trey Burleson',
	skills: 'Skills | Trey Burleson',
	contact: 'Contact | Trey Burleson',
	projects: 'Projects | Trey Burleson',
};

export const SKILLS = [
	{ label: 'HTML 5', icon: 'html.svg' },
	{ label: 'Golang', icon: 'golang.svg' },
	{ label: 'JavaScript', icon: 'javascript.svg' },
	{ label: 'React.js', icon: 'reactjs.svg' },
	{ label: 'Node.js', icon: 'nodejs.svg' },
	{ label: 'Chakra', icon: 'chakra.svg' }
];

export const SOCIAL_LINKS = [
	{
		username: '/impolqris',
		link: 'https://github.com/impolqris',
		icon: 'github.svg'
	},
	{
		username: '/treydburleson',
		link: 'https://www.linkedin.com/in/treydburleson',
		icon: 'linkedin.svg'
	},
	{
		username: '/impolqris',
		link: 'https://dev.to/impolqris',
		icon: 'devto.png'
	},
	{
		username: 'Email me',
		link: 'mailto:treyburleson890@gmail.com',
		icon: 'email.svg'
	}
];

export const PAGE_LINKS = ['/about', '/skills', '/projects', '/contact'];

export const PROJECTS = [
	{
		projenabled: false,
		name: 'Todo List',
		key: 'Todoifier',
		clink: 'https://todo.treysweb.dev/',
		ghlink: '',
		image: 'todo-project.png'
	},
];